import blankProfilePicture from "@/assets/shared/blank-profile-picture.svg";

// const getRoundedTimeFromNow = (
//   offsetMs: number,
//   roundingUnitMs: number = 30 * 60 * 1000
// ): string => {
//   const now = new Date().getTime();
//   const targetTime = now + offsetMs;

//   // Round up to the next 30-minute interval to ensure it's always in the future
//   const roundedTime = Math.ceil(targetTime / roundingUnitMs) * roundingUnitMs;

//   // Add extra buffer to ensure it's definitely in the future
//   const futureTime = roundedTime + roundingUnitMs;
//   const date = new Date(futureTime);

//   // Format as YYYY-MM-DD HH:MM:SS
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

const getDateAt = (daysFromNow: number, hour: number, minute = 0): string => {
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + daysFromNow);
  targetDate.setHours(hour, minute, 0, 0);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate()).padStart(2, "0");
  const hours = String(targetDate.getHours()).padStart(2, "0");
  const minutes = String(targetDate.getMinutes()).padStart(2, "0");
  const seconds = String(targetDate.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const directoryProfiles = [
  {
    id: "1",
    uuid: "1",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "United States",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    anyPastMeetings: true,
    meetingsCount: 10,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 3,
        experience: 4,
      },
    ],
  },
  {
    id: "2",
    uuid: "2",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "United Kingdom",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 5,
    anyPastMeetings: true,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 2,
        experience: 1,
      },
    ],
  },
  {
    id: "3",
    uuid: "3",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "Canada",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    anyPastMeetings: true,
    meetingsCount: 3,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 1,
        experience: 5,
      },
    ],
  },
  {
    id: "4",
    uuid: "4",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "Singapore",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 2,
    anyPastMeetings: true,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 2,
        experience: 3,
      },
    ],
  },
  {
    id: "5",
    uuid: "5",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "Spain",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 1,
    anyPastMeetings: false,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 3,
        experience: 3,
      },
    ],
  },
  {
    id: "6",
    uuid: "6",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "United States",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 8,
    anyPastMeetings: false,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 4,
        experience: 1,
      },
    ],
  },
  {
    id: "7",
    uuid: "7",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "United Kingdom",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 7,
    anyPastMeetings: false,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 5,
        experience: 3,
      },
    ],
  },
  {
    id: "8",
    uuid: "8",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "Canada",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 6,
    anyPastMeetings: false,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 5,
        experience: 5,
      },
    ],
  },
  {
    id: "9",
    uuid: "9",
    firstName: "First Name",
    lastName: "Last Name",
    slug: "first-name-last-name",
    email: "firstname@example.com",
    country: "Singapore",
    title: "Title",
    companyName: "Company Name",
    imageUrl: blankProfilePicture,
    linkedinUrl: "",
    meetingsCount: 4,
    anyPastMeetings: true,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getDateAt(1, 10, 0),
        endTime: getDateAt(1, 10, 30),
      },
      {
        startTime: getDateAt(2, 14, 0),
        endTime: getDateAt(2, 14, 30),
      },
    ],
    userProgramProfile: [
      {
        expertise: 1,
        experience: 1,
      },
    ],
  },
];
